import { useState } from 'react';
import Offcanvas from 'olive-react-myoneui/lib/Offcanvas';
import Button from 'olive-react-myoneui/lib/Button';
import Notification from './notification';
import { useTranslation } from "react-i18next";
import { commonModuleName } from '../../constants/config';
import { clearNotificationCount } from '../../../api/afterLogin/notification';

function OffcanvasNotification({ triggerTitle, triggerSubTitle, notificationcount, setNotificationCount }) {

  const { t } = useTranslation(commonModuleName);
  const [notification, setNotification] = useState("false");
  const [show, setShow] = useState(false);

  const handleClear = async () => {
    const host     = window.location.hostname
    await clearNotificationCount(host);
    setNotification("")
  }
  
  const handleClose = () => {
    setShow(false);
    setNotificationCount("")
  }

  const handleShow = () => {
    setShow(true);
    setNotificationCount("")
  }
  const offCanvasKeyDown = (e) => e.stopPropagation();
  
  return (
    <>
      <a className={`mk-bell-icon res-notification-link ${notificationcount > 0 ? `mk-show-dot` : ""} `} onClick={handleShow}>
        <span className='notification-text'>{triggerTitle} {triggerSubTitle}</span>
        <span className="mk-notification-dot"></span>
      </a>
      <Offcanvas show={show} onHide={handleClose} placement="end" className="pb-0 res-notification" onKeyDown={offCanvasKeyDown}>
        <Offcanvas.Header closeButton backButton={`${t("Back")}`} className="pb-0">
          <Offcanvas.Title>{t("Notifications")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Notification notification={notification} setNotification={setNotification}/>
        </Offcanvas.Body>
        <Offcanvas.Footer>
          <Button variant="default" onClick={handleClear}>
          {t("clear_all_notification")}
          </Button>
        </Offcanvas.Footer>
      </Offcanvas>
    </>
  );
}

export default OffcanvasNotification;